import React from 'react';

const LABELS = { llm: 'LLM only', vector: 'Vector RAG', hybrid: 'Hybrid RAG', graph: 'Graph RAG' };

const RagExperimentResults = ({ result, error, query }) => {
  if (error) return <div className="text-center py-16"><p className="font-serif italic text-lg text-binge-sub">The experiment didn’t answer.</p><p className="text-sm text-binge-faint mt-2">{error}</p></div>;
  if (!result) return null;
  return (
    <section className="animate-fadein py-10">
      <div className="flex flex-wrap items-baseline justify-between gap-3 mb-7">
        <div><p className="text-[11px] tracking-[0.2em] uppercase text-binge-gold">Private RAG experiment</p><h2 className="font-serif text-3xl mt-2">{LABELS[result.architecture]}</h2></div>
        <p className="text-xs text-binge-faint">{(result.latency_ms / 1000).toFixed(1)}s · {result.provider || 'retrieval only'}</p>
      </div>
      <p className="font-serif italic text-binge-sub mb-7">“{query}”</p>
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {(result.recommendations || []).map((item, index) => (
          <article key={`${item.catalogue_id || item.title}-${index}`} className="rounded-lg p-5" style={{ border: '1px solid rgba(241,236,226,0.13)', background: 'rgba(241,236,226,0.035)' }}>
            <p className="text-[10px] tracking-[0.18em] uppercase text-binge-faint">Pick {index + 1}{item.catalogue_id ? ` · TMDB ${item.catalogue_id}` : ''}</p>
            <h3 className="font-serif text-xl mt-2">{item.title}{item.year ? ` (${item.year})` : ''}</h3>
            <p className="text-sm leading-6 text-binge-sub mt-3">{item.reason}</p>
          </article>
        ))}
      </div>
      <details className="mt-8 rounded-lg p-5 text-sm" style={{ border: '1px solid rgba(241,236,226,0.1)' }}>
        <summary className="cursor-pointer text-binge-gold">Inspect retrieval trace</summary>
        <div className="mt-5 space-y-5 text-binge-sub">
          <div><p className="text-xs uppercase tracking-widest text-binge-faint mb-2">Candidates sent to the model</p><ol className="list-decimal pl-5 space-y-1">{(result.retrieval_candidates || []).map((c) => <li key={c.catalogue_id}>{c.title} ({c.year || 'year unknown'}) · {c.source} · {Number(c.reranking_score ?? c.retrieval_score ?? 0).toFixed(3)}</li>)}</ol></div>
          <pre className="overflow-auto text-xs leading-5 p-4 rounded" style={{ background: '#0e0c0e', maxHeight: 420 }}>{JSON.stringify(result.trace, null, 2)}</pre>
        </div>
      </details>
      <p className="text-xs text-binge-faint mt-5">{result.warning}</p>
    </section>
  );
};

export default RagExperimentResults;
